import { useSelector } from 'react-redux'

import { stepIdFromCommentsDockSelector, intentIdFromCommentsDockSelector } from './selectors'

export function useStepIdFromCommentsDock(): string | undefined {
  return useSelector(stepIdFromCommentsDockSelector)
}

export function useIntentIdFromCommentsDock(): string | undefined {
  return useSelector(intentIdFromCommentsDockSelector)
}
